import React, { useEffect, useState } from "react";
import { useHandleEmbedSessionQuery } from "generated/graphql";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Loader from "components/atoms/Loader";
import paths from "routes/paths";
import { getEmbedScript } from "utils/embedScriptSrc";

const embedScriptSrc = getEmbedScript();

const BookSession = () => {
  const history = useHistory();
  const { token } = useParams<{ token: string }>();
  const [meetingUrl, setMeetingUrl] = useState("");

  const { data, loading, error } = useHandleEmbedSessionQuery({
    variables: {
      token,
    },
  });

  useEffect(() => {
    if (
      embedScriptSrc &&
      !loading &&
      !error &&
      data?.handleEmbedConsultantSession
    ) {
      if (
        data.handleEmbedConsultantSession.isUsed ||
        !data.handleEmbedConsultantSession.sessionUrl
      ) {
        history.push(`${paths.bookSessionFailure}?reason=used`);
      }
      if (document.getElementById("embed-meetings-script")) return;

      setMeetingUrl(data.handleEmbedConsultantSession.sessionUrl!);
      const script = document.createElement("script");
      script.src = embedScriptSrc;
      script.async = true;
      script.id = "embed-meetings-script";

      document.body.appendChild(script);
    }

    if (error) {
      history.push(`${paths.bookSessionFailure}?reason=unknown`);
    }
  }, [data, loading, error, history]);

  return (
    <>
      {meetingUrl ? (
        <div
          className="meetings-iframe-container"
          data-src={meetingUrl}
          style={{ minHeight: "700px" }}
        />
      ) : (
        <Loader />
      )}
    </>
  );
};

export default BookSession;
